/**
 * Aligns GET tearsheet cashflow scenario `result` with the shape returned by
 * POST /admin/cashflow-model-calc (legacy drafts may have been stored as protojson).
 */
export function normalizeStoredCashflowResult(raw) {
  if (raw == null) {
    return null;
  }
  const o = typeof raw === 'string' ? JSON.parse(raw) : { ...raw };
  if (!o || typeof o !== 'object') {
    return null;
  }
  if (o.roas100Avg6 != null && o.roas_100_avg_6 == null) {
    o.roas_100_avg_6 = o.roas100Avg6;
  }
  if (o.cohortRevenueBreakdown != null && o.cohort_revenue_breakdown == null) {
    o.cohort_revenue_breakdown = o.cohortRevenueBreakdown;
  }
  if (o.fundRepaymentBreakdown != null && o.fund_repayment_breakdown == null) {
    o.fund_repayment_breakdown = o.fundRepaymentBreakdown;
  }
  if (o.items && typeof o.items === 'object') {
    const it = o.items;
    if (it.profitAndLoss != null && it.profit_and_loss == null) {
      it.profit_and_loss = it.profitAndLoss;
    }
    if (it.twelveBalance != null && it.twelve_balance == null) {
      it.twelve_balance = it.twelveBalance;
    }
    if (it.balanceSheet != null && it.balance_sheet == null) {
      it.balance_sheet = it.balanceSheet;
    }
    if (it.cashFlow != null && it.cash_flow == null) {
      it.cash_flow = it.cashFlow;
    }
  }
  return o;
}
